<template lang="pug">
#card-analise-socioambiental-operacao
    BaseHeader(
            :titulo="$t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.titulo')",
            voltarPara="emit"
            @voltarClicado="fechar()"
            :exibeBotao='false'
        )

    section.card-analise-socioambiental-operacao__body
        div(
            v-for='(diagnosticoProtocolo, index) in diagnosticosProtocolo',
            :key='index',
            @click='$refs.modalResultadoDiagnosticoRef.abrirModal(diagnosticoProtocolo)'
        )
            .card-analise-socioambiental-operacao__body__item(
                :class='status[diagnosticoProtocolo.status].classeCollapse'
            )
                .d-wrap.align-content-stretch
                    .d-flex.align-items-center
                        i.card-analise-socioambiental-operacao__body__item__icone(
                            :class='status[diagnosticoProtocolo.status].classeIcone'
                        )
                        .font-weight-bold {{ $t(`mensagens.operacao.monitoramento.${diagnosticoProtocolo.nome}`) }}: {{ diagnosticoProtocolo.grupo[0].nome }}

                    .car-vinculado.font-weight-bold(v-if='diagnosticoProtocolo.carsVinculados') {{ $t('mensagens.operacao.car') }}: {{ diagnosticoProtocolo.carsVinculados }}

                i.el-icon-arrow-right.el-icon--right.card-analise-socioambiental-operacao__body__item--acao

    section.card-analise-socioambiental-operacao__aprovar-recusar(
        v-if='habilitarAnalise'
    )
        h2 {{ $t('mensagens.comuns.situacao') }}

        el-form(label-position='top', size='small')
            el-form-item.mt-2
                el-radio-group(v-model='escolhaAprovarReprovar')
                    el-radio.mr-4(:label="$t('mensagens.operacao.acoes.aprovar')")
                    el-radio(:label="$t('mensagens.operacao.acoes.reprovar')")

            el-form-item.mt-1(v-if='opcaoReprovarAtiva')
                div(slot='label' style='display: grid')
                    span.campo_obrigatorio {{ $t('mensagens.operacao.motivo') }}

                    el-select(
                        v-model='motivosReprovacaoSelecao',
                        multiple,
                        clearable
                    )
                        el-option(
                            v-for='{ nome, id } in motivosReprovacao',
                            :key='nome',
                            :label='nome',
                            :value='id'
                        )

            el-form-item
                div(slot='label')
                    span(v-if='opcaoReprovarAtiva', style='color: red') *
                    span {{ $t('mensagens.operacao.justificativa') }}

                    el-tooltip(
                        v-if='opcaoReprovarAtiva',
                        :content="$t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.textoJustificativa')",
                        placement='right',
                        effect='light'
                    )
                        i.mdi.mdi-information-outline.ml-2

                el-input(
                    v-model='justificativaAprovarReprovar',
                    :maxlength='255',
                    :placeholder="$t('mensagens.operacao.justificativa')",
                    type='textarea',
                    resize='none',
                    :rows='2'
                )

    section.card-analise-socioambiental-operacao__acao(v-if='habilitarAnalise')
        BaseButton.mr-2(size='small', @click='fechar()')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(
            @click='aprovarRecusarOperacao()',
            type='primary',
            size='small'
        )
            | {{ $t('mensagens.operacao.acoes.finalizarAnalise') }}

    section.card-analise-socioambiental-operacao__acao(v-else)
        BaseButton(size='small', @click='fechar()')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(
            v-if='habilitarBotaoCadastrar',
            @click='cadastrarOperacao()',
            type='primary',
            size='small'
        )
            | {{ editandoOperacao ? $t('mensagens.comuns.salvar') : $t('mensagens.operacao.acoes.cadastrarOperacao') }}

    ModalResultadoDiagnostico(ref='modalResultadoDiagnosticoRef')
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ModalResultadoDiagnostico from '@/components/operacao/gestao/ModalResultadoDiagnostico.vue';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import OperacaoService from '@/services/OperacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { calcularBuffer } from '@/utils/calcularBuffer.js';

export default {
    name: 'CardAnaliseSocioambientalOperacao',
    components: {
        BaseHeader,
        ModalResultadoDiagnostico,
        BaseButton
    },
    emits: [
        'aprovarOperacao',
        'reprovarOperacao',
        'fechar',
        'cadastrarOperacao'
    ],

    props: {
        dadosDiagnostico: {
            type: Object,
            required: true
        },
        editandoOperacao: {
            type: Boolean,
            required: false,
            default: false
        },
        habilitarBotaoCadastrar: {
            type: Boolean,
            required: false,
            default: true
        },
        habilitarAnalise: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        opcaoReprovarAtiva() {
            return (this.escolhaAprovarReprovar === this.$t('mensagens.operacao.acoes.reprovar'));
        }
    },

    data() {
        return {
            diagnosticosProtocolo: [],
            escolhaAprovarReprovar: this.$t('mensagens.operacao.acoes.aprovar'),
            status: {
                ALERTA: {
                    classeIcone: 'alerta flow flow-warning-sign'
                },
                SUCESSO: {
                    classeIcone: 'sucesso el-icon-circle-check'
                },
                ATENCAO: {
                    classeIcone: 'atencao flow flow-warning-sign'
                }
            },
            justificativaAprovarReprovar: null,
            mostrarDialogCamadas: false,
            mostrarCardAprovarReprovar: false,
            motivosReprovacao: [],
            motivosReprovacaoSelecao: [],
            territorios: [],
            diagnosticoPessoa: false
        };
    },

    async mounted() {
        await this.realizarDiagnosticoListagem();
        await this.buscarMotivosReprovacao();
    },

    methods: {
        async aprovarRecusarOperacao() {
            const payload = {
                justificativa: this.justificativaAprovarReprovar,
                motivos: this.motivosReprovacaoSelecao
            };

            if (this.escolhaAprovarReprovar === this.$t('mensagens.operacao.acoes.reprovar')) {
                if (
                    this.justificativaAprovarReprovar == null ||
                    this.justificativaAprovarReprovar.length === 0
                ) {
                    this.$notify.warning({
                        message: this.$t('mensagens.operacao.notificacao.preenchaJustificativa')
                    });
                    return;
                }

                if (this.motivosReprovacaoSelecao.length === 0) {
                    this.$notify.warning({
                        message: this.$t('mensagens.operacao.notificacao.motivoReprovacao')
                    });
                    return;
                }

                this.$emit('reprovarOperacao', payload);
            } else {
                this.$emit('aprovarOperacao', payload);
            }
        },

        async buscarMotivosReprovacao() {
            await OperacaoService.buscarMotivosReprovacao()
                .then(({ data }) => {
                    this.motivosReprovacao = data.itens;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroMotivoReprovacao')
                    });
                });
        },

        cadastrarOperacao() {
            this.$emit('cadastrarOperacao');
        },

        async realizarDiagnosticoListagem() {
            this.dadosDiagnostico.territorios.forEach(element => {
                if (element.visualizarOperacao) {
                    this.territorios.push({
                        id: element.idTerritorio,
                        geometria: element.geometria
                    });
                    this.diagnosticoPessoa = true;
                }
            });

            await DiagnosticoSocioambientalService.realizarDiagnosticoSocioambientalProtocolo(
                this.dadosDiagnostico
            )
                .then(({ data }) => {
                    const diagnosticosModificados = data.map(grupo => {
                        if (grupo.nome && grupo.nome.includes('Gleba:')) {
                            grupo.nome = 'GLEBA';
                        } else if (grupo.nome && grupo.nome.includes('Território:')) {
                            grupo.nome = 'TERRITORIO';
                        } else if (grupo.nome && grupo.nome.includes('Pessoa:')) {
                            grupo.nome = 'PESSOA';

                            if (this.diagnosticoPessoa === true) {
                                grupo.diagnosticoPessoa = this.diagnosticoPessoa;
                                grupo.territorios = this.territorios;
                            }
                        }
                        grupo.grupo.map(item => {
                            const titulo = item.titulo;
                            switch (titulo) {
                                case 'Pessoa Analisada':
                                    item.codigo = 'PESSOA_ANALISADA';
                                    break;
                                case 'Gleba Analisada':
                                    item.codigo = 'GLEBA_ANALISADA';
                                    break;
                                case 'Área Analisada':
                                    item.codigo = 'AREA_ANALISADA';
                                    break;
                                case 'Proximidades (≅10 Km)':
                                case 'Proximidades (≅3 Km)':
                                    const territorioData = data.find(item => item.nome === 'TERRITORIO');
                                    item.diagnostico.forEach(diagnostico => {
                                        const bufferGeometria = calcularBuffer(territorioData.territorioGeometria, diagnostico.bufferMetros);
                                        diagnostico.geometriaProximidade = bufferGeometria;

                                    });
                                    item.territorioProximidade = false;
                                    item.proximidadeBuffer = true;
                                    item.codigo = 'PROXIMIDADE_TERRITORIO_ANALISADO';
                                    break;
                                case 'Pessoa':
                                    item.codigo = 'PESSOA';
                                    break;
                                default:
                                    break;
                            }
                        });
                        return grupo;
                    });
                    this.diagnosticosProtocolo = diagnosticosModificados;
                })

                .catch(erro => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroProtocoloSocio')
                    });
                    this.fechar();
                });
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
#card-analise-socioambiental-operacao {
    .card-analise-socioambiental-operacao__body {
        gap: 2px;
        display: flex;
        flex-direction: column;
        margin: 20px;

        .card-analise-socioambiental-operacao__body__item {
            height: 75px;
            background-color: var(--white);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: $default-border-radius;
            transition: 0.3s ease-in-out;

            .card-analise-socioambiental-operacao__body__item__icone {
                font-size: 24px;
                margin: 0 15px;
            }

            .card-analise-socioambiental-operacao__body__item--acao {
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                margin-right: 20px;
            }

            .alerta {
                color: #df675b;
            }

            .sucesso {
                color: var(--secondary-two);
            }

            .atencao {
                color: #d7bc25;
            }
        }

        .card-analise-socioambiental-operacao__body__item:hover {
            opacity: 0.7;
        }
    }

    .card-analise-socioambiental-operacao__acao {
        display: flex;
        justify-content: space-between;
        margin: 20px;
    }

    .card-analise-socioambiental-operacao__aprovar-recusar {
        background-color: var(--white);
        margin: 20px;
        padding: 20px;
        border-radius: $default-border-radius;
    }

    .campo_obrigatorio::before {
        content: '* ';
        color: red;
    }

    .car-vinculado {
        margin-left: 55px;
    }
}
</style>
